export class EmployeeUI {
    id: number;
    internalCode: string;
    firstName: string;
    lastName: string;
    
}
